// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/arrow-out.svg';

export const ArrowOut = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
